module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-5-c33953ae141fe3049ff3e20e311d1b0e.png";